// src/plugins/stockHelper.js
const StockHelper = {
  install(Vue) {

    Vue.prototype.$getSimpleStockMessage = function(quantity) {
      if (quantity >= 100) {
        return 'Disponible';
      } else if (quantity >= 1) {
        return 'Stock limitado';
      } else {
        return 'Agotado';
      }
    };

    Vue.prototype.$getSimpleStockClass = function(quantity) {
      if (quantity >= 100) {
        return 'stock-available';
      } else if (quantity >= 1) {
        return 'stock-low';
      } else {
        return 'stock-out';
      }
    };
  }
};

export default StockHelper;